import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { Box, ButtonBase, Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import AppTab from "../../components/Common/AppTab";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomButton from "../../components/Form/CustomButton";
import { getAdvertInterestRate, getGeneral, resetAdvertState, resetReuseableSettingActionState, resetReuseableSettingState, updateReuseable, verify_admin } from "../../store/actions";
import LoadingDialog from "../../components/Common/LoadingDialog";

const Settings = ({ leftSideBarType, advertPricingData, updateSettingData, settingError, licenseCategories, verifyAdmin, loanInterestRatesList, generalCommonCode }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    // Max Loan Tenure
    const [maxLoanTenure, setMaxLoanTenure] = useState("7");

    // Interest Rate Options
    const [tabValue, setTabValue] = useState();
    const [tabList, setTabList] = useState([]);
    // Interest rates data structure
    const [interestRates, setInterestRates] = useState({});
    // removed interest rates list
    const [removedIds, setRemovedIds] = useState([]);
    // loan interest rate list
    const [loanInterestRates, setLoanInterestRates] = useState([{ value: '' }]);
    const [removeLoanRatesIds, setRemoveLoanRatesIds] = useState([]);

    useEffect(() => {
        dispatch(resetReuseableSettingState());
        dispatch(getGeneral());
        setIsLoading(true);
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (verifyAdmin?.user?.data?.profile) {
            setMaxLoanTenure(verifyAdmin?.user?.data?.profile?.current_max_loan_tenure || '');
        }
    }, [verifyAdmin])

    useEffect(() => {
        if (Array.isArray(loanInterestRatesList) && loanInterestRatesList?.length > 0) {
            setIsLoading(false);
            setLoanInterestRates(loanInterestRatesList.map(rate => ({ id: rate.id, value: rate.interest_rate })));
        }
    }, [loanInterestRatesList])

    useEffect(() => {
        if (generalCommonCode?.code === 'success') {
            setIsLoading(false);
        } else if (generalCommonCode?.code && generalCommonCode?.code !== "success") {

            setIsLoading(false);
        }

    }, [generalCommonCode])

    useEffect(() => {
        if (updateSettingData?.code === 'success') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: "Settings updated successfully.",
                type: "success",
            });
            dispatch(resetReuseableSettingActionState());
            dispatch(getAdvertInterestRate());
            dispatch(verify_admin());
            dispatch(getGeneral());
            removedIds && setRemovedIds([]);
        } else if (updateSettingData?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: updateSettingData?.message || "Failed to update settings, please try again.",
                type: "error",
            });
        }
    }, [updateSettingData])

    useEffect(() => {
        dispatch(getAdvertInterestRate());
        return () => {
            dispatch(resetAdvertState());
        }
    }, []);

    useEffect(() => {
        if (licenseCategories?.length > 0) {
            const filteredCategories = licenseCategories.filter((item) => item?.is_active === 1) || [];
            let tabs = filteredCategories.map((category) => ({
                value: category?.name,
                label: category?.name,
                id: category?.id,
            }));
            setTabList(tabs);
            setTabValue(tabs?.[0]?.value);
        }
    }, [licenseCategories])

    useEffect(() => {
        if (advertPricingData?.code === 'success' && licenseCategories?.length > 0) {
            if (advertPricingData) {
                const filteredCategories = licenseCategories.filter((item) => item?.is_active === 1) || [];
                let interestRateData = {};
                filteredCategories.forEach((category) => {
                    interestRateData[category?.name] = {
                        id: advertPricingData?.library?.[category?.name]?.[0]?.id || null,
                        licenseId: category?.id,
                        newMotorcycle: advertPricingData?.library?.[category?.name]?.filter((item) => item?.bike_advert_type === "new") || [],
                        usedMotorcycle: advertPricingData?.library?.[category?.name]?.filter((item) => item?.bike_advert_type === "used") || [],
                    };
                });
                setInterestRates(interestRateData);
            }
        } else if (advertPricingData?.code === 'invalid_field') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: advertPricingData?.message || "Invalid Fields",
                type: "error",
            });
        }
        // else if (advertPricingData?.code) {
        //     setIsLoading(false);
        // }
    }, [advertPricingData, licenseCategories])

    const handleRateChange = (classType, vehicleType, index, value) => {
        setInterestRates(prev => ({
            ...prev,
            [classType]: {
                ...(prev[classType] || {}),
                [vehicleType]: (prev[classType]?.[vehicleType] || []).map((rate, i) =>
                    i === index ? { ...rate, interest_rate: value } : rate
                ),
            },
        }));
    };

    const handleAddRate = (classType, vehicleType) => {
        setInterestRates(prev => ({
            ...prev,
            [classType]: {
                ...(prev[classType] || {}),
                newMotorcycle: prev[classType]?.newMotorcycle || [],
                usedMotorcycle: prev[classType]?.usedMotorcycle || [],
                [vehicleType]: [...(prev[classType]?.[vehicleType] || []), { interest_rate: "" }],
            },
        }));
    };

    const handleRemoveRate = (classType, vehicleType, index, id) => {
        if (id) {
            let removeRate = [...removedIds];
            removeRate.push(id);
            setRemovedIds(removeRate);
        } else {
            setInterestRates(prev => ({
                ...prev,
                [classType]: {
                    ...(prev[classType] || {}),
                    [vehicleType]: (prev[classType]?.[vehicleType] || []).filter((_, i) => i !== index),
                },
            }));
        }
    };

    const handleSaveLoanTenure = () => {
        setIsLoading(true);
        dispatch(updateReuseable({
            api: 'dealer',
            reuseable: { action: "edit_setting", max_loan_tenure: maxLoanTenure }
        }));
    }

    const handleSaveInterestRateOptions = () => {
        const filteredCategories = licenseCategories.filter((item) => item?.is_active === 1) || [];
        setIsLoading(true);
        let payload = {
            action: 'edit_interest_rate',
            interest_rates: filteredCategories.flatMap((category) => {
                const categoryRates = interestRates[category.name];
                if (!categoryRates) return [];
                const newRates = categoryRates?.newMotorcycle?.map((rate) => {
                    if (!rate.id) {
                        return (
                            {
                                id: rate.id || null,
                                license_category_id: rate.id ? null : category.id,
                                bike_advert_type: rate.id ? null : "new",
                                interest_rate: parseFloat(rate.interest_rate) || 0,
                            }
                        )
                    } else {
                        return (
                            {
                                id: rate.id || null,
                                interest_rate: parseFloat(rate.interest_rate) || 0,
                            }
                        )
                    }

                });

                const usedRates = categoryRates?.usedMotorcycle.map((rate) => {
                    if (!rate.id) {
                        return (
                            {
                                id: rate.id || null,
                                license_category_id: rate.id ? null : category.id,
                                bike_advert_type: rate.id ? null : "used",
                                interest_rate: parseFloat(rate.interest_rate) || 0,
                            }
                        )
                    } else {
                        return (
                            {
                                id: rate.id || null,
                                interest_rate: parseFloat(rate.interest_rate) || 0,
                            }
                        )
                    }

                });
                return [...newRates, ...usedRates];
            }),
        };
        dispatch(updateReuseable({
            api: 'dealer',
            reuseable: payload,
        }));

        if (removedIds.length > 0) {
            setIsLoading(true);
            dispatch(updateReuseable({ api: 'dealer', reuseable: { action: 'delete_interest_rate', interest_rates: removedIds } }));
        }
    }

    const handleLoanRateChange = (index, value) => {
        let updatedRates = [...loanInterestRates];
        updatedRates[index].value = value;
        setLoanInterestRates(updatedRates);
    }

    const handleDeleteLoanRate = (index, id) => {
        if (id) {
            setRemoveLoanRatesIds(prev => [...prev, id]);
        }
        setLoanInterestRates(prev => prev.filter((_, i) => i !== index));
    }

    const handleSaveLoanInterestRates = () => {
        setIsLoading(true);
        dispatch(updateReuseable({ api: 'dealer', reuseable: { action: 'edit_loan_interest_rate', interest_rates: loanInterestRates?.map(rate => ({ id: rate?.id || null, interest_rate: rate.value })) || [] } }));
        if (removeLoanRatesIds.length > 0) {
            setIsLoading(true);
            dispatch(updateReuseable({ api: 'dealer', reuseable: { action: 'delete_interest_rate', interest_rates: removeLoanRatesIds } }));
        }
    }

    const renderRateInputs = (vehicleType, vehicleLabel, showBorder = true) => {
        const rates = interestRates?.[tabValue]?.[vehicleType];
        return (
            <Box sx={{ borderBottom: showBorder ? '1px solid #E6E6E6' : 'none', py: 2 }}>
                <Grid container alignItems="flex-start">
                    <Grid item xs={4}>
                        <Box sx={{ pt: 1.5, fontWeight: 500, fontSize: 14, color: '#282828' }}>
                            {vehicleLabel}
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        {rates?.map((rate, index) => (
                            <>
                                {
                                    rate?.id && removedIds.includes(rate.id) ? null :
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                                            <Box sx={{ width: 150 }}>
                                                <CustomTextField
                                                    placeholder="0.00"
                                                    type="number"
                                                    values={rate?.interest_rate}
                                                    onChange={(val) => handleRateChange(tabValue, vehicleType, index, val)}
                                                    InputProps={{
                                                        endAdornment: <Box sx={{ color: '#808588', fontSize: 14 }}>%</Box>,
                                                    }}
                                                />
                                            </Box>
                                            <CustomButton
                                                title="Remove"
                                                press={() => handleRemoveRate(tabValue, vehicleType, index, rate?.id)}
                                                backgroundColor="#F9F9F9"
                                                textColor="#808588"
                                                borderStyle="1px solid #ffffffff"
                                                height={40}
                                                fontSize={13}

                                            />
                                        </Box>
                                }
                            </>
                        ))}
                        <Link className="text-muted-hover" onClick={() => handleAddRate(tabValue, vehicleType)} style={{ marginTop: 12, display: 'inline-block' }}>
                            <span style={{ color: "#B48A3C" }}>
                                <Icon icon="fluent:add-24-filled" /> Add new rate
                            </span>
                        </Link>
                    </Grid>
                </Grid>
            </Box>
        );
    };

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <Notification notification={notification} setNotification={setNotification} errors={settingError} />
                <LoadingDialog open={isLoading} />
                <Container fluid>
                    <div style={{ marginBottom: "10px" }} className="header-2 d-flex align-items-center">Settings</div>
                    <span className="text-muted pb-3">Configure default settings and preferences for your dealership.</span>

                    {/* Max Loan Tenure Card */}
                    <Box sx={{
                        backgroundColor: '#ffffffff',
                        borderRadius: 2,
                        p: 3,
                        mt: 3,
                        border: '1px solid #E2E2E2'
                    }}>
                        <Box sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>Max Loan Tenure</Box>
                        <Box sx={{ color: '#808588', fontSize: 14, mb: 2 }}>
                            Set the default maximum financing period.
                        </Box>
                        <Box sx={{ width: 200 }}>
                            <CustomTextField
                                placeholder="0"
                                type="number"
                                values={maxLoanTenure}
                                onChange={(val) => setMaxLoanTenure(val)}
                                InputProps={{
                                    endAdornment: <Box sx={{ color: '#808588', fontSize: 14 }}>years</Box>,
                                }}
                                error={settingError?.max_loan_tenure}
                            />
                        </Box>
                        <CustomButton title={'Save'} press={() => handleSaveLoanTenure()} marginTop={15} />
                    </Box>

                    {/* Interest Rate Options Card */}
                    <Box sx={{
                        backgroundColor: '#ffffffff',
                        borderRadius: 2,
                        p: 3,
                        mt: 3,
                        border: '1px solid #E2E2E2'
                    }}>
                        <Box sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>Interest Rate Options</Box>
                        <Box sx={{ color: '#808588', fontSize: 14, mb: 2 }}>
                            Create multiple interest rate options for each licence class and vehicle condition.
                        </Box>

                        <AppTab
                            tabValue={tabValue}
                            setTabValue={setTabValue}
                            tabList={tabList}
                            marginBottom={0}
                        />

                        {/* Table Header */}
                        <Box sx={{
                            display: 'flex',
                            backgroundColor: '#F5F5F5',
                            p: 1.5,
                            mt: 2,
                            borderRadius: 1,
                        }}>
                            <Box sx={{ width: '33%', fontWeight: 500, fontSize: 14, color: '#1D1B1B' }}>
                                Vehicle Type
                            </Box>
                            <Box sx={{ width: '67%', fontWeight: 500, fontSize: 14, color: '#1D1B1B' }}>
                                Interest Rate (%)
                            </Box>
                        </Box>

                        {/* Rate Inputs */}
                        <Box sx={{ mt: 0, ml: 1 }}>
                            {renderRateInputs('newMotorcycle', 'New Motorcycle', true)}
                            {renderRateInputs('usedMotorcycle', 'Used Motorcycle', false)}
                        </Box>
                        <CustomButton title={'Save'} press={() => handleSaveInterestRateOptions()} marginTop={15} />
                    </Box>
                    {/* Loan Interest Card */}
                    <Box sx={{
                        backgroundColor: '#ffffffff',
                        borderRadius: 2,
                        p: 3,
                        mt: 3,
                        border: '1px solid #E2E2E2'
                    }}>
                        <Box sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>Loan Interest Rate List</Box>
                        <Box sx={{ color: '#808588', fontSize: 14, mb: 2 }}>
                            Set the loan interest rate list.
                        </Box>
                        <Box sx={{ width: 200 }}>
                            {
                                loanInterestRates?.map((rate, index) => (
                                    <div className="d-flex align-items-center">
                                        <div className="d-grid">
                                            <CustomTextField
                                                values={rate?.value}
                                                onChange={(e) => { handleLoanRateChange(index, e) }}
                                                placeholder={'0.00'}
                                                type="number"
                                                error={settingError?.[`interest_rates.0.interest_rate`]}
                                            />
                                        </div>
                                        <ButtonBase style={{ marginLeft: 10, padding: 5, paddingInline: 10, borderRadius: 7 }} onClick={() => { handleDeleteLoanRate(index, rate?.id) }} >
                                            <Icon icon="ri-delete-bin-6-line" color='#F65151' width={20} height={20} />
                                        </ButtonBase>
                                    </div>
                                ))
                            }

                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 2 }}>
                            <CustomButton
                                title={'Add'}
                                press={() => { setLoanInterestRates(prev => [...prev, { value: '' }]) }}
                            />
                            <CustomButton title={'Save'} press={() => { handleSaveLoanInterestRates() }} />
                        </Box>

                    </Box>
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Layout, ReuseableReducer, General, Login }) {
    return {
        leftSideBarType: Layout.leftSideBarType,
        advertPricingData: General.advertInterestRate,
        updateSettingData: ReuseableReducer.editReuseableSetting,
        licenseCategories: General.license_categories,
        loanInterestRatesList: General.loan_interest_rates,
        generalCommonCode: General.generalCommonCode,
        settingError: ReuseableReducer.error?.errors,
        verifyAdmin: Login.verifyAdmin,
    };
}

export default connect(mapStateToProps)(Settings);
